import { render } from "./BaseCheckbox.vue?vue&type=template&id=8efd1c38&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=8efd1c38&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efd1c38"]])

export default __exports__